import {createApp} from 'vue'
import {createPinia} from 'pinia'
import "core-js/stable";
import App from '@/console-signup/App.vue'

import '@/shared/global';
import '@/console-signup/global';
import '@/console-signup/assets/scss/main.scss';
import sharedMixin from '@/shared/mixins';

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.mixin(sharedMixin);
app.mount('#app');
